module.exports = __webpack_public_path__ + "static/media/banner2.1cea4ed6.jpg";